module.exports = __webpack_public_path__ + "img/special_orbital.388c8bc6.png";